/* eslint-disable import/no-unresolved */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getHiddenBlockTypes, toggleHiddenBlockType } from '../../../actions';
import { Icon } from '@plone/volto/components';
import responsibilitiesSVG from '../../../icons/responsibilities.svg';
import wikiSVG from '../../../icons/wiki.svg';
import mediamanagerSVG from '../../../icons/medienmanager.svg';
import newSVG from '../../../icons/new.svg';

const BlocksFilter = () => {
  const dispatch = useDispatch();
  const hiddenBlockTypes = useSelector(
    (state) => state.hiddenblocktypes?.items || [],
  );
  const blockFilters = [
    {
      title: 'Text',
      descripton: 'Zeigt nur Text-Blöcke an',
      type: 'slate',
      icon: newSVG,
    },
    {
      title: 'Dokumente',
      descripton: 'Zeigt nur Download-Blöcke an',
      type: 'download',
      icon: wikiSVG,
    },
    {
      title: 'Bilder',
      descripton: 'Zeigt nur Bild-Blöcke an',
      type: 'image',
      icon: mediamanagerSVG,
    },
    {
      title: 'Tabellen',
      descripton: 'Zeigt nur Tabellen-Blöcke an',
      type: 'slateTable',
      icon: responsibilitiesSVG,
    },
  ];
  const toggleBlocks = (blockType) => {
    dispatch(toggleHiddenBlockType(blockType));
  };

  useEffect(() => {
    dispatch(getHiddenBlockTypes());
  }, [dispatch]);

  return (
    <div className={'filtercontainer'}>
      {blockFilters.map((block, idx) => (
        <div className={`filter-wrapper`} key={idx}>
          <button
            aria-label={block.descripton}
            title={block.descripton}
            data-active={hiddenBlockTypes.includes(block.type)}
            className={`filter`}
            onClick={() => toggleBlocks(block.type)}
          >
            <Icon className={'icon'} name={block.icon} size={'1.25rem'} />
            <span>{block.title}</span>
          </button>
        </div>
      ))}
    </div>
  );
};

export default BlocksFilter;
